import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export interface MyFeaturedRow {
  id: string;
  user_id: string;
  kind: string;
  template_label: string | null;
  caption: string | null;
  status: "pending" | "approved" | "rejected";
  source_image_path: string;
  permanent_image_path: string | null;
  is_custom_upload: boolean;
  submission_source: "credits" | "custom_pass" | "featured_pass" | "tryon";
  like_count: number;
  show_instagram: boolean;
  instagram_handle: string | null;
  reject_reason: string | null;
  created_at: string;
}

export function useMyFeaturedSubmissions() {
  const { user } = useAuth();
  const [rows, setRows] = useState<MyFeaturedRow[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    const { data } = await supabase
      .from("featured_submissions")
      .select(
        "id,user_id,kind,template_label,caption,status,source_image_path,permanent_image_path,is_custom_upload,submission_source,like_count,show_instagram,instagram_handle,reject_reason,created_at",
      )
      .eq("user_id", user.id)
      .order("created_at", { ascending: false })
      .limit(80);
    setRows((data ?? []) as MyFeaturedRow[]);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { rows, loading, refresh, setRows };
}
